import React, { useState } from 'react';
import { Button, Card } from 'react-bootstrap';
import AddUserProject from '../MyProfile/user-projects/AddUserProject';
import { Add } from '@mui/icons-material';
import { Typography } from '@mui/material';
import { useRole } from '../../hooks/useRole';

const NoProject = ({fetchProjectData}) => {
  const [open, setOpen] = useState(false);
  const role = useRole();
  return (
    <Card>
      <Card.Body>
        <div className="d-flex align-items-center flex-column p-3">
          <Typography sx={{ mb: 1, fontSize: '20px' }}>
            No Projects Available
          </Typography>
          {role === 'org-admin' || role === 'org-manager' ? (
            <Button
              variant="link"
              onClick={() => setOpen(true)}
              style={{ textDecoration: 'none' }}>
              <Add /> Add Project
            </Button>
          ) : (
            <Typography>
              Please wait for your organization admin to assign some projects.
            </Typography>
          )}
        </div>
      </Card.Body>
      <AddUserProject fetchProjectData={fetchProjectData} open={open} setOpen={setOpen} />
    </Card>
  );
};

export default NoProject;
